import React from "react";
import { Trash2, ScanSearch } from "lucide-react";
import OrderedIconActionContextRow from "../../ui/OrderedIconActionContextRow";
import { ReparentMenuIcon } from "./icons";
import SceneGraphReparentBodyList from "./SceneGraphReparentBodyList";

export default function SceneGraphCameraContextMenu({
  contextMenuCameraIds,
  reparentSubmenuOpen,
  setReparentOnlySubmenuKey,
  closeContextSubmenus,
  isPhysicsRunning,
  worldRootTargetBodyUuid,
  groupedMeshParentOptions,
  bodies,
  inspectContextMenuTarget,
  handleDeleteCameras,
  handleMoveCamerasToBody,
}) {
  return (
    <>
      <div className="px-2 py-1.5 text-[11px] font-semibold text-gray-400 uppercase tracking-wide">
        {contextMenuCameraIds.length} {contextMenuCameraIds.length === 1 ? "camera" : "cameras"}{" "}
        selected
      </div>
      <div className="px-2 pb-1.5">
        <OrderedIconActionContextRow
          activeSubmenuKey={reparentSubmenuOpen ? "reparent" : null}
          setActiveSubmenuKey={setReparentOnlySubmenuKey}
          submenuClassName="mt-1 min-w-[180px] rounded-md border border-gray-600 p-0.5 shadow-xl"
          submenuStyle={{ backgroundColor: "rgba(40, 40, 40, 0.95)" }}
          actions={[
            {
              key: "inspect",
              label: "Inspect",
              icon: <ScanSearch className="w-4 h-4" aria-hidden="true" />,
              onDefaultClick: inspectContextMenuTarget,
            },
            {
              key: "delete",
              label: "Delete",
              icon: <Trash2 className="w-4 h-4" aria-hidden="true" />,
              disabled: isPhysicsRunning,
              disabledByPhysics: isPhysicsRunning,
              onHover: closeContextSubmenus,
              onClick: () => handleDeleteCameras(contextMenuCameraIds),
            },
            {
              key: "reparent",
              label: "Reparent",
              icon: <ReparentMenuIcon />,
              disabled: isPhysicsRunning || contextMenuCameraIds.length === 0,
              disabledByPhysics: isPhysicsRunning,
              onDefaultClick: () => {
                if (
                  isPhysicsRunning ||
                  contextMenuCameraIds.length === 0 ||
                  !worldRootTargetBodyUuid
                )
                  return;
                handleMoveCamerasToBody(worldRootTargetBodyUuid);
              },
              submenu: (
                <SceneGraphReparentBodyList
                  groupedParentOptions={groupedMeshParentOptions}
                  bodies={bodies}
                  onSelectBody={handleMoveCamerasToBody}
                />
              ),
            },
          ]}
        />
      </div>
    </>
  );
}
